export default {
  name: 'LayoutCol',
  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: 'div'
    },
    offset: Number,
  },
  computed: {
    gutter() {
      let parent = this.$parent;
      while (parent && parent.$options.name !== 'layout-row') {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    }
  },
  render(h){
    let classList = [];
    let style = {};
    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px';
      style.paddingRight = style.paddingLeft;
      style.marginBottom = this.gutter + 'px';
    }
    ['span', 'offset'].forEach(prop => {
      if (this[prop] || this[prop] === 0) {
        classList.push(
          prop !== 'span'
            ? `mc-col-${prop}-${this[prop]}`
            : `mc-col-${this[prop]}`
        );
      }
    });

    return h(this.tag, {
      class: [ classList],
      style
    }, this.$slots.default)
  }
}


// WEBPACK FOOTER //
// ./src/components/layout-col.js